@if (productCode && (cart$ | async); as cart) {
  <form [formGroup]="addToCartForm" (submit)="addToCart()">
    @if (showQuantity) {
      <div class="quantity">
        <label>{{ 'addToCart.quantity' | cxTranslate }}</label>
        @if (hasStock) {
          <app-efa-item-counter
            [max]="maxQuantity"
          [control]="addToCartForm.get('quantity')"></app-efa-item-counter>
        }
        <span class="info">{{
          hasStock
          ? ('addToCart.inStock' | cxTranslate)
          : ('addToCart.outOfStock' | cxTranslate)
        }}</span>
      </div>
    }
    @if ((hasStock && !cart.fromConfigurator) || (hasStock && cart.fromConfigurator && (isCalledFromSERP || isCalledFromDPD))) {
      <button
        class="c-btn-add-to-cart btn btn-primary submit-btn"
        type="submit"
        [disabled]="quantity <= 0 || quantity > maxQuantity || !priceAvailable">
        <span> <cx-icon [type]="myIconTypes.CART_WHITE"></cx-icon></span>
        <span style="color: inherit; background-color: inherit;" class="btn-text">{{ 'addToCart.addToCart' | cxTranslate }}</span>
      </button>
    }
    @if (showQuantityHint && hasStock && !cart.fromConfigurator) {
      <div class="quantity-hint">
        <span class="hint">{{ 'eAddToCart.showQuantityHint' | cxTranslate }}</span>
      </div>
    } @else {
      @if (showQuantityHint && hasStock) {
        <div class="quantity-hint">
          <span class="hint">{{ 'eAddToCart.showQuantityHintForConfiguratorEntry' | cxTranslate }}</span>
        </div>
      }
    }
  </form>
}
